export default __webpack_public_path__ + "static/media/messages search 1.9828be47.svg";